import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/clinical-solutions/medical-device-clinical-trials")({
  head: () => buildRouteHead("/en/services/clinical-solutions/medical-device-clinical-trials", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/full-service-medical-device-cro", replace: true });
  },
});
